"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosComplianceVerificationSchema = exports.APosVerificationSourceSchema = exports.APosVerificationResultSchema = exports.APosVerificationMethodSchema = exports.APosVerificationTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosVerificationTypeSchema = zod_1.z.enum(['age', 'identity', 'license', 'permit']);
exports.APosVerificationMethodSchema = zod_1.z.enum(['manual', 'id_scan', 'barcode_scan', 'biometric', 'database', 'document']);
exports.APosVerificationResultSchema = zod_1.z.enum(['passed', 'failed', 'override']);
// ----- Phase G (O19) — where the verification originated -----
exports.APosVerificationSourceSchema = zod_1.z.enum([
    'pos', 'online_checkout', 'online_account_signup', 'delivery_handoff',
]);
exports.APosComplianceVerificationSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    verificationId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    transactionId: id_schema_1.EntityIdSchema.optional(),
    orderId: id_schema_1.EntityIdSchema.optional(),
    customerId: id_schema_1.EntityIdSchema.optional(),
    verificationType: exports.APosVerificationTypeSchema,
    method: exports.APosVerificationMethodSchema,
    result: exports.APosVerificationResultSchema,
    verifiedAge: zod_1.z.number().int().optional(),
    minimumAgeRequired: zod_1.z.number().int().optional(),
    documentType: zod_1.z.string().optional(),
    documentExpiry: zod_1.z.number().optional(),
    overrideReason: zod_1.z.string().max(500).optional(),
    overrideBy: id_schema_1.EntityIdSchema.optional(),
    // Phase G: relaxed to optional — online verifications have no clerk/staff.
    staffId: id_schema_1.EntityIdSchema.optional(),
    verifiedAt: zod_1.z.number(),
    // ----- Phase G (O19) online-checkout additive fields (ALL optional/defaulted, backward-compatible) -----
    source: exports.APosVerificationSourceSchema.optional(),
    providerId: zod_1.z.string().optional(),
    providerRefId: zod_1.z.string().optional(),
    providerResponse: zod_1.z.object({
        status: zod_1.z.enum(['passed', 'failed', 'manual_review']),
        confidence: zod_1.z.number().optional(),
        checksRun: zod_1.z.array(zod_1.z.string()).default([]),
        reason: zod_1.z.string().optional(),
    }).optional(),
    verifiedName: zod_1.z.string().optional(),
    verifiedDob: zod_1.z.string().optional(),
    verifiedAddress: zod_1.z.object({
        street: zod_1.z.string(), city: zod_1.z.string(), state: zod_1.z.string(), zip: zod_1.z.string(),
    }).optional(),
    validUntil: zod_1.z.number().optional(),
    idImageStored: zod_1.z.boolean().default(false),
    idImageS3Key: zod_1.z.string().optional(),
    retainUntil: zod_1.z.number().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=compliance-verification.schema.js.map